const animateImages = () => {
  let container = document.querySelector(
    '.teacher-feature-page-how-it-works__container'
  );
  let images = document.querySelectorAll('.js-animating-image');
  let texts = document.querySelectorAll('.js-animating-text');

  window.addEventListener('scroll', () => {
    let position = container.getBoundingClientRect();
    if (position.top < window.innerHeight && position.bottom >= 0) {
      images.forEach(image => image.classList.add('animating'));
      texts.forEach(text => text.classList.add('animating'));
    }
  });
};

$(document).on('turbolinks:before-visit', function() {
  Turbolinks.clearCache();
});

preventCachedExecution(function () {
  if (document.querySelector('.teachers-feature-page')) {
    animateImages();
  }
});
